export default __webpack_public_path__ + "assets/images/8ea0113e4f2861de4d907d6d612655a8.svg";